import { CreateEventForm } from "@ac-expo/api";
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  FormMap,
  IconButton,
  Separator,
} from "@ac-expo/ui-components";
import { useGoogleApiContext } from "@web-app/src/context/googleApi.context";
import { useState } from "react";
import { useFormContext } from "react-hook-form";

export function EventCustomMapModal() {
  const [isOpen, setIsOpen] = useState(false);
  const { control } = useFormContext<CreateEventForm>();
  const { isLoaded } = useGoogleApiContext();

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <IconButton
          svgType="crosshair"
          svgProps={{ size: 24, className: "text-blue-500" }}
          className="px-1"
          type="button"
          variant={"outline-blue"}
        />
      </DialogTrigger>
      <DialogContent className="max-h-[calc(100vh-60px)] max-w-[calc(100vw-20px)] overflow-auto bg-white md:max-h-[calc(100vh-120px)] md:max-w-[700px]">
        <DialogHeader>
          <DialogTitle>Choisir une position</DialogTitle>
        </DialogHeader>
        <Separator />
        <FormMap
          control={control}
          name="place.address"
          showUserGeolocationButton
          isMapApiLoaded={isLoaded}
        />

        <DialogFooter>
          <Button
            variant={"blue"}
            type="button"
            onClick={() => setIsOpen(false)}
          >
            Valider
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default EventCustomMapModal;
